export class PrintModule {

	constructor(menuModule) {
		this.$trigger = $("[data-print-trigger]");
		this.init();
	}

	init() {
		this.$trigger.on('click', (e) => {
			this.printPage();
		});
	}

	printPage() {
		window.print();
	}
}
